import { promoParam } from '../consts/links.js';

/** Hardcode custom  styles for menu icons (these customization are not in the sitesettings yet) */
const customIcons = [
    {
        name: 'ПИК',
        label: 'Ипотека в новостройках ПИК',
        href: `/special/pik/?${promoParam}`,
        style: { padding: '6px' },
    },
];
const customIconsMap = () => customIcons.reduce((acc, icon) => {
    acc[icon.href] = icon;
    return acc;
}, {});
const getCustomIcon = (href) => {
    const icons = customIconsMap();
    return icons[href] || {};
};

export { customIcons, getCustomIcon };
//# sourceMappingURL=customIcons.js.map
